import {DatePipe} from '@angular/common';
import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {Router} from '@angular/router';
import {
    AcabimAuthService, AcabimProject, AcabimSite, ColumnFilter, DataTableColumnData,
    DatatableComponent, DataTableConfig, DataTableDataSource, DataTableLazyLoadDataSource,
    DataTableLazyLoadRefresher, DataTableObservableCompletionListener, DataTableObservableErrorListener, GenericPayloadModel, GenericPayloadType,
    PaginatedRequest, PaginatedResponse, ProjectApiService, Status, TableAction
} from '@cas-hub/acabim-common-client';
import {Subscription} from 'rxjs';
import {map, tap} from 'rxjs/operators';
import {MessageService, PrimeNGConfig} from 'primeng/api';

@Component({
    selector: 'acabim-admin-archived-projects',
    templateUrl: './archived-projects.component.html',
    styleUrls: ['./archived-projects.component.scss'],
    providers: [MessageService]

})
export class ArchivedProjectsComponent implements OnInit {
    @Input() _currentSite?: AcabimSite = undefined;

    @ViewChild('archivedProjectsTable') public dataTable!: DatatableComponent;
    projectData: GenericPayloadModel[] = [];
    dataTypes = GenericPayloadType;
    public archivedProjectDataSources: DataTableDataSource<any>[] = [];
    actionTitle = '';
    displayDataModal = false;
    displayWarningModal = false;
    errorMessage: GenericPayloadModel[] = [];

    manager = false;
    action: TableAction[] = [{id: 0, name: 'Reactivate'}];

    public get isProcessing(): boolean {
        return this._currentProcess !== undefined;
    }


    private _currentProcess?: Subscription = undefined;

    constructor(
        public readonly router: Router,
        private readonly projectAPIService: ProjectApiService,
        private readonly authService: AcabimAuthService,
        private messageService: MessageService, private primengConfig: PrimeNGConfig,
        protected readonly datePipe: DatePipe) {
        this.authService.getUser().subscribe(user => {
            this.manager = user ? (user.roles.includes('Admin') || user.roles.includes('SuperAdmin')) : false;
            console.log(this.manager);
        });
    }

    ngOnInit(): void {
        this.primengConfig.ripple = true;
        console.log(this.manager);

        if (this.manager) {
            this.action.push({id: 1, name: 'Delete'});
        }
        this.archivedProjectDataSources.push(
            new ArchivedProjectDataSource((first, length, sortOrder, sortField, filters) => {
                    const paginatedRequest = PaginatedRequest.FromDatatableRefresher(first, length, sortOrder, sortField);
                    // @ts-ignore
                    return this.projectAPIService.getAllProjects(paginatedRequest, {
                        includeGroups: false,
                        // @ts-ignore
                        filterSiteId: [this._currentSite.id],
                        filterStatus: Status.inactive
                    })
                        .pipe(map(data => data as PaginatedResponse<AcabimProject>), map(data => ({
                            totalRecords: data.totalRecords,
                            data: data.data
                        })), tap(data => {
                            data.data.forEach(project => {
                                project.lastModifiedDate = this.getDate(project.lastModifiedDate);
                            });
                        }));
                }, this.authService, (tableName: string, error: Error) => {
                    console.log('Error in retrieving data in table ', tableName);
                },
                (tableName: string) => {
                    console.log('completion');
                }, (action: TableAction) => {
                    if (action.id === 0) {
                        this.actionTitle = 'Reactivate';
                        this.onProjectAction();
                    } else if (action.id === 1) {
                        this.actionTitle = 'Delete';
                        this.onProjectAction();
                    }
                }
            )
        );
    }

    getDate(date: string): string {
        const newDate = new Date(date);
        return (this.datePipe.transform(newDate, 'dd MMM yyyy') as string);
    }

    private onProjectAction() {
        if (this.archivedProjectDataSources[0].selectedData.length < 1) {
            return;
        }
        this.archivedProjectDataSources[0].selectedData.forEach(project => {
            this.projectData.push({type: this.dataTypes.text, key: project.id, label: project.name, value: project.id});
            this.displayDataModal = true;
        });
    }


    public projectAction(action: boolean) {
        if (action) {
            if (this.actionTitle === 'Reactivate') {
                this.archivedProjectDataSources[0].selectedData.forEach(project => {
                    this._currentProcess = this.projectAPIService.unarchiveProject(project.id).subscribe(data => {
                        this._currentProcess = undefined;
                        this.projectData = [];
                        this.archivedProjectDataSources[0].selectedData = [];
                        this.displayDataModal = false;
                        this.dataTable?.requestImmediateDataRefresh();
                    }, error => {
                        this._currentProcess = undefined;
                        this.messageService.clear();
                        this.messageService.add({
                            severity: 'error',
                            summary: 'Error',
                            detail: error
                        });
                    });
                });
            } else if (this.actionTitle === 'Delete') {
                this.archivedProjectDataSources[0].selectedData.forEach(project => {
                    this._currentProcess = this.projectAPIService.deleteProject(project.id).subscribe(data => {
                        this._currentProcess = undefined;
                        this.projectData = [];
                        this.archivedProjectDataSources[0].selectedData = [];
                        this.displayDataModal = false;
                        this.dataTable?.requestImmediateDataRefresh();
                    }, error => {
                        this._currentProcess = undefined;
                        this.displayDataModal = false;
                        this.displayWarningModal = true;
                        Object.keys(JSON.parse(JSON.stringify(error)).error).forEach(key => {
                            this.errorMessage.push({type: this.dataTypes.text, key: key, label: key, value: JSON.parse(JSON.stringify(error)).error[key]});
                        });
                    });
                });
            }

        } else {

            this.projectData = [];
            this.displayDataModal = false;

        }
    }

    closeErrorDialog() {
        this.displayWarningModal = false;
    }

    setModal(value: boolean): void {
        this.displayDataModal = value;
        if (!value) {
            this.projectData = [];
            this.archivedProjectDataSources[0].selectedData = [];
        }
    }
}

export class ArchivedProjectDataSource extends DataTableLazyLoadDataSource<AcabimProject> {


    readonly columnData: DataTableColumnData[] =
        [
            {displayName: 'Name', objectPropertyName: 'name'},
            {displayName: 'Description', objectPropertyName: 'description'},
            {displayName: 'Last Modified', objectPropertyName: 'lastModifiedDate'}
        ];
    readonly config: DataTableConfig = {
        tableHeading: '',
        isSearchEnabled: true,
        searchPlaceHolder: 'Search WorkOrder',
        emptyMessage: '',
        globalFilterFields: [],
        hasCheckbox: true,
        hasDetailsButton: false,
        isLazyLoadingEnabled: true,
        isPaginationEnabled: true,
        hasFilters: true,
        isExportEnabled: false,
        hasActions: true
    };
    readonly columnFilters: ColumnFilter[] = [];
    readonly actions: TableAction[] = [{id: 0, name: 'Reactivate'}, {id: 1, name: 'Delete'}];
    manager = false;

    onDataExpanded(value: AcabimProject): void {
    }

    constructor(readonly refresher: DataTableLazyLoadRefresher<AcabimProject>,
                private readonly authService: AcabimAuthService,
                readonly observableErrorListener?: DataTableObservableErrorListener,
                readonly observableCompleteListener?: DataTableObservableCompletionListener,
                readonly actionListener?: (action: TableAction) => void) {
        super(refresher, observableErrorListener, observableCompleteListener);
        this.authService.getUser().subscribe(user => {
                this.manager = user ? (user.roles.includes('Admin') || user.roles.includes('SuperAdmin')) : false;
                console.log(this.manager);
                if (this.manager) {
                    this.actions.push({id: 1, name: 'Delete'});
                }
            }
        );
    }

    onAction(action: TableAction): void {
        if (this.actionListener) {
            this.actionListener(action);
        }
    }
}
